import angular from 'angular';

import RwListItemModule from './components/rw-list-item-module';

import RwListComponent from './rw-list-component';

export default angular
  .module('rw-list', [
    RwListItemModule.name,
  ])
  .component('rwList', new RwListComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-list/rw-list-module.js